// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicDetailSeparator_container_29UcK","label":"BasicDetailSeparator_label_1xDLZ"};